/*!
 * mtj-atc-label.js
 * Relabels the primary Add-to-cart button on the MTJ PDP to "Claim My Momento".
 * (ATC sub-line removed 2026-06-11 per request.)
 */
(function () {
  "use strict";

  var MTJ_HANDLE = (window.MTJ_HANDLE || "ilovehue-momento-traveler-s-journal");
  var MTJ_V2_HANDLE = "ilovehue-momento-traveler-s-journal-v2";
  var NEW_LABEL = "Claim My Momento";
  var V2_LABEL = "Claim My Momento and Free Charms";

  function isV2() {
    try {
      var qs = (location && location.search) || "";
      if (/[?&]view=mtj-v2(&|$)/i.test(qs)) return true;
      if (document.getElementById("mtj-builder")) return true;
      if (((location && location.pathname) || "").indexOf("/products/" + MTJ_V2_HANDLE) !== -1) return true;
      if (document.querySelector('variant-picker[handle="' + MTJ_V2_HANDLE + '"]')) return true;
    } catch (e) {}
    return false;
  }
  var ATC_REGEX = /^\s*add to cart\s*$/i;
  var BLOCK_REGEX = /sold\s*out|unavailable|notify\s*me|coming\s*soon/i;

  var TIMER_KEY = "ilh_eta_start_v2";
  var TOTAL_MIN = 107;

  function isMtjPdp() {
    try {
      var path = (location && location.pathname) || "";
      if (path.indexOf("/products/" + MTJ_HANDLE) !== -1) return true;
      var vp = document.querySelector('variant-picker[handle="' + MTJ_HANDLE + '"]');
      if (vp) return true;
      var bb = document.querySelector('buy-buttons[template="mtj"]');
      if (bb) return true;
    } catch (e) {}
    return false;
  }

  function isAddToCart(text) {
    if (!text) return false;
    return ATC_REGEX.test(text.replace(/\s+/g, " "));
  }

  function buttonTextExcludingSub(btn) {
    var sub = btn.querySelector(".mtj-atc-sub");
    var tc = "";
    var cn = btn.childNodes;
    for (var i = 0; i < cn.length; i++) {
      var n = cn[i];
      if (n === sub) continue;
      if (n.nodeType === 3) tc += n.nodeValue;
      else if (n.nodeType === 1) tc += n.textContent || "";
    }
    return tc.replace(/\s+/g, " ").trim();
  }

  function hasBlockingState(btn) {
    if (!btn) return true;
    if (btn.getAttribute("aria-busy") === "true") return true;
    if (btn.classList) {
      if (btn.classList.contains("is-loading")) return true;
      if (btn.classList.contains("loading")) return true;
    }
    if (BLOCK_REGEX.test(buttonTextExcludingSub(btn))) return true;
    return false;
  }

  function relabelButton(btn) {
    if (!btn) return;
    if (hasBlockingState(btn)) return;
    var label = isV2() ? V2_LABEL : NEW_LABEL;
    var childNodes = btn.childNodes;
    var swapped = false;
    for (var i = 0; i < childNodes.length; i++) {
      var n = childNodes[i];
      if (n.nodeType === 3 && isAddToCart(n.nodeValue)) {
        if (n.nodeValue !== label) n.nodeValue = label;
        swapped = true;
      }
    }
    if (swapped) return;
    if (ATC_REGEX.test(buttonTextExcludingSub(btn))) {
      var subEl = btn.querySelector(".mtj-atc-sub");
      for (var k = childNodes.length - 1; k >= 0; k--) {
        var c = childNodes[k];
        if (c === subEl) continue;
        btn.removeChild(c);
      }
      btn.insertBefore(document.createTextNode(label), subEl || null);
    }
  }

  function ensureSubline(btn) {
    if (!btn) return;
    var existing = btn.querySelector(".mtj-atc-sub");
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    btn.classList && btn.classList.remove("mtj-atc-has-sub");
  }

  function ensureGuarantee(btn) {
    if (!btn || !isV2()) return;
    var bb = btn.closest("buy-buttons") || btn.parentElement;
    if (!bb || !bb.parentElement) return;
    if (hasBlockingState(btn)) {
      var stale = bb.parentElement.querySelector(".mtj-v2-guarantee");
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
      return;
    }
    if (bb.parentElement.querySelector(".mtj-v2-guarantee")) return;
    ensureGuaranteeStyles();
    var g = document.createElement("div");
    g.className = "mtj-v2-guarantee";
    g.setAttribute("aria-label", "100-day money-back guarantee, even if you use it");
    g.innerHTML =
      '<svg class="mtj-v2-guarantee__badge" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
        '<path d="M12 2.2 4 5.1v6c0 4.6 3.2 7.9 8 9.7 4.8-1.8 8-5.1 8-9.7v-6L12 2.2z" fill="#2ec866" fill-opacity=".14" stroke="#2ec866" stroke-width="1.5" stroke-linejoin="round"/>' +
        '<path d="m8.4 12 2.5 2.5 4.7-5" fill="none" stroke="#2ec866" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="mtj-v2-guarantee__txt">100-day money-back guarantee, even if you use it</span>';
    bb.parentElement.insertBefore(g, bb.nextSibling);
  }

  function ensureGuaranteeStyles() {
    if (document.getElementById("mtj-v2-guarantee-styles")) return;
    var st = document.createElement("style");
    st.id = "mtj-v2-guarantee-styles";
    st.textContent = [
      ".mtj-v2-guarantee{display:flex;align-items:center;justify-content:center;gap:7px;margin-top:11px;font-family:'Satoshi',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;font-size:13.5px;font-weight:700;letter-spacing:-0.006em;color:#3a2a22;line-height:1.3;text-align:center;}",
      ".mtj-v2-guarantee__badge{flex:0 0 auto;display:block;}",
      ".mtj-v2-guarantee__txt{font-weight:700;}"
    ].join("");
    (document.head || document.documentElement).appendChild(st);
  }

  function ensureStyles() {
    if (document.getElementById("mtj-atc-sub-styles")) return;
    var st = document.createElement("style");
    st.id = "mtj-atc-sub-styles";
    st.textContent = [
      ".mtj-atc-has-sub{display:flex !important;flex-direction:column !important;align-items:center !important;justify-content:center !important;gap:5px !important;line-height:1.15;height:auto !important;padding-top:14px !important;padding-bottom:14px !important;}",
      ".mtj-atc-sub{display:inline-flex;align-items:center;gap:6px;font-family:'Satoshi',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;font-size:12.5px;font-weight:400;letter-spacing:-0.003em;text-transform:none;}",
      ".mtj-atc-sub__orb{display:inline-block;width:7px;height:7px;border-radius:50%;background:#2ec866;box-shadow:0 0 0 0 rgba(46,200,102,.55);animation:mtjAtcOrbPulse 2.1s cubic-bezier(.4,0,.2,1) infinite;flex:0 0 auto;}",
      ".mtj-atc-sub__txt{display:inline-flex;align-items:baseline;gap:4px;flex-wrap:wrap;justify-content:center;color:currentColor;opacity:.55;}",
      ".mtj-atc-sub__label{color:currentColor;opacity:.92;font-weight:500;}",
      ".mtj-atc-sub__sep{color:currentColor;opacity:.5;}",
      ".mtj-atc-sub__timer{color:#2ec866;opacity:.85;font-variant-numeric:tabular-nums;font-weight:600;letter-spacing:.005em;}",
      "@keyframes mtjAtcOrbPulse{0%{box-shadow:0 0 0 0 rgba(46,200,102,.55);transform:scale(1);}70%{box-shadow:0 0 0 6px rgba(46,200,102,0);transform:scale(1.05);}100%{box-shadow:0 0 0 0 rgba(46,200,102,0);transform:scale(1);}}",
      "@media(prefers-reduced-motion:reduce){.mtj-atc-sub__orb{animation:none;}}"
    ].join("");
    (document.head || document.documentElement).appendChild(st);
  }

  function getTimerStart() {
    var st = 0;
    try {
      st = parseInt(localStorage.getItem(TIMER_KEY) || "0", 10) || 0;
      if (!st) { st = Date.now(); localStorage.setItem(TIMER_KEY, String(st)); }
    } catch (e) { st = Date.now(); }
    return st;
  }

  function formatRemaining(remMs) {
    if (remMs <= 0) return "0m";
    var totalSec = Math.floor(remMs / 1000);
    var totalMin = Math.floor(totalSec / 60);
    if (totalMin < 1) return totalSec + "s";
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    if (h > 0) return h + "h " + m + "m";
    return m + "m";
  }

  function tickTimer() {
    var start = getTimerStart();
    var endMs = start + TOTAL_MIN * 60 * 1000;
    var remMs = endMs - Date.now();
    var txt = formatRemaining(remMs);
    var els = document.querySelectorAll("[data-mtj-atc-sub-timer]");
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }

  var timerInterval = null;
  function startTimer() {
    if (timerInterval) return;
    tickTimer();
    timerInterval = setInterval(tickTimer, 1000);
  }

  function findPrimaryAtcButtons() {
    var buttons = [];
    var seen = [];
    function addAll(nodeList) {
      for (var i = 0; i < nodeList.length; i++) {
        var b = nodeList[i];
        if (seen.indexOf(b) === -1) {
          seen.push(b);
          buttons.push(b);
        }
      }
    }
    try {
      addAll(document.querySelectorAll('form.shopify-product-form buy-buttons button[type="submit"]'));
      addAll(document.querySelectorAll('buy-buttons[template="mtj"] button[type="submit"]'));
      addAll(document.querySelectorAll('buy-buttons button[type="submit"]'));
    } catch (e) {}
    return buttons;
  }

  function relabelAll() {
    if (!isMtjPdp()) return;
    ensureStyles();
    var btns = findPrimaryAtcButtons();
    for (var i = 0; i < btns.length; i++) {
      if (isV2()) relabelButton(btns[i]);
      ensureSubline(btns[i]);
      if (isV2()) ensureGuarantee(btns[i]);
    }
  }

  var observer = null;
  function startObserver() {
    if (observer) return;
    try {
      observer = new MutationObserver(function () { relabelAll(); });
      var target = document.body || document.documentElement;
      if (!target) return;
      observer.observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) {}
  }

  function start() {
    relabelAll();
    startObserver();
    try {
      document.addEventListener("variant:change", relabelAll);
      document.addEventListener("product:rerendered", relabelAll);
      document.addEventListener("shopify:section:load", relabelAll);
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  try { window.addEventListener("load", relabelAll); } catch (e) {}
})();
// build: 2026-05-12T02:40-07:00 atc-subline-only-keep-add-to-cart
